export interface UserReferralStats {
  total_referrals: number;
  successful_referrals: number;
  pending_referrals: number;
  total_earnings: number;
  this_month_earnings: number;
  referral_code: string;
  referral_link: string;
  conversion_rate: number;
  top_referral_sources: ReferralSource[];
  recent_referrals: RecentReferral[];
}

export interface ReferralSource {
  source: string;
  count: number;
  earnings: number;
  conversion_rate: number;
}

export interface RecentReferral {
  id: string;
  user_name: string;
  email: string;
  joined_date: string;
  status: 'pending' | 'active' | 'completed';
  earnings: number;
  source: string;
}

export const exampleReferralStats: UserReferralStats = {
  total_referrals: 47,
  successful_referrals: 23,
  pending_referrals: 8,
  total_earnings: 156.75,
  this_month_earnings: 34.50,
  referral_code: 'ZIPPY123',
  referral_link: 'https://zippyhealth.io/ref/ZIPPY123',
  conversion_rate: 48.9,
  top_referral_sources: [
    {
      source: 'Social Media',
      count: 18,
      earnings: 67.50,
      conversion_rate: 55.6
    },
    {
      source: 'Email',
      count: 12,
      earnings: 45.00,
      conversion_rate: 41.7
    },
    {
      source: 'Direct Link',
      count: 8,
      earnings: 28.00,
      conversion_rate: 37.5
    },
    {
      source: 'Word of Mouth',
      count: 6,
      earnings: 22.50,
      conversion_rate: 50.0
    }
  ],
  recent_referrals: [
    {
      id: '1',
      user_name: 'Sarah Johnson',
      email: 'sarah.j@email.com',
      joined_date: '2024-01-15',
      status: 'active',
      earnings: 5.00,
      source: 'Social Media'
    },
    {
      id: '2',
      user_name: 'Mike Chen',
      email: 'mike.chen@email.com',
      joined_date: '2024-01-14',
      status: 'pending',
      earnings: 0.00,
      source: 'Email'
    },
    {
      id: '3',
      user_name: 'Lisa Rodriguez',
      email: 'lisa.r@email.com',
      joined_date: '2024-01-13',
      status: 'completed',
      earnings: 10.00,
      source: 'Direct Link'
    },
    {
      id: '4',
      user_name: 'David Kim',
      email: 'david.kim@email.com',
      joined_date: '2024-01-12',
      status: 'active',
      earnings: 5.00,
      source: 'Word of Mouth'
    }
  ]
}; 